import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import UpdateTable from "../../../components/Common/UpdatedTable"
import {
  downloadFinanceReceivable,
  fetchFinanceSOA,
} from "../../../services/finance/finance"
import moment from "moment"
import JournalEntryFilter from "./filter"
import { useLocation } from "react-router-dom"
import NumberFormat from "../../../utils/numberFormat"
import SoaTable from "../../../components/Common/Fields/soaTable"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import { UFDate, UFInputNumber } from "../../../components/Common/Fields/Input"
import { FormProvider, useFieldArray, useForm } from "react-hook-form"
import resetIcon from "../../../assets/icons/reset.svg"
import { set } from "lodash"
import DueOn from "../../../components/Common/chooseFields/dueOn"
import closeIcon from "../../../assets/icons/close.svg"
import LoadingButton from "../../../components/Common/LoadingButton"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

const StatementOfAcc = ({ fromDashboard }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Statement Of Account${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`

  const schema = yup.object().shape({
    ageing: yup.array().of(
      yup.object().shape({
        from_days: yup
          .number()
          .required("From days is required")
          .min(0, "From days cannot be negative"),

        to_days: yup
          .number()
          .required("To days is required")
          .min(0, "To days cannot be negative")
          .test(
            "to-days-valid",
            "To days must be 0 or greater than From days",
            function (value) {
              const { from_days } = this.parent
              // allow 0 explicitly OR must be greater than from_days
              return value === 0 || value > from_days
            }
          ),
      })
    ),
  })

  const path = window.location.pathname
  console.log(`path`, path)

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const [search, setSearch] = useState("")
  const [page, setPage] = useState(1)
  const [fetchedData, setFetchedData] = useState([])
  const [dateFrom, setDatefrom] = useState("")
  const [dateTo, setDateto] = useState("")
  const [acc, setAcc] = useState("")
  const [dueOn, setDueOn] = useState("")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  const [pagination, setPagination] = useState(null)

  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [refresh, setRefresh] = useState(0)

  const [rSelected, setRSelected] = useState(1)
  const [isModal, setIsModal] = useState(false)

  const [ageingPeriod, setAgeingPeriod] = useState([])

  const location = useLocation()
  const desimalrange = localStorage.getItem("desimalrange")
  const handlePageChange = newPage => {
    setPage(newPage)
  }

  const { control, handleSubmit, watch, reset, setValue, getValues } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      ageing: [{ from_days: 0, to_days: "" }],
    },
  })

  const toggleModal = () => {
    setIsModal(!isModal)
  }
  useEffect(() => {
    let agenigArr = []
    if (ageingPeriod.length > 0) {
      agenigArr = ageingPeriod?.map(period => ({
        label:
          period?.to_days == 0
            ? `pending_over_${period?.from_days}_days`
            : `pending_${period?.from_days}_to_${period?.to_days}_days`,
        min: period?.from_days == 0 ? null : period?.from_days,
        max: period?.to_days == 0 ? null : period?.to_days,
      }))
    }
    const fetchData = async () => {
      try {
        const response = await fetchFinanceSOA({
          params: `${page ? `&page=${page}` : ""}${
            dateFrom ? `&start_date=${dateFrom}` : ""
          }${`&sortOrder=asc`}${dateTo ? `&end_date=${dateTo}` : ""}${
            startDate ? `&start_date=${startDate}` : ""
          }${endDate ? `&end_date=${endDate}` : ""}${`&sizePerPage=16`}${
            location?.state || acc
              ? `&account_id=${
                  location?.state?.item?.ledger_id
                    ? location?.state?.item?.ledger_id
                    : location?.state?.ledger_id
                    ? location?.state?.ledger_id
                    : location?.state?.id
                    ? location?.state?.id
                    : acc
                }`
              : ""
          }${dueOn ? `&due_on=${dueOn}` : ""}${`&sortOrder=asc`}${
            agenigArr?.length
              ? `&${agenigArr
                  .map(
                    (item, i) =>
                      `pending_buckets[${i}][label]=${item.label}&pending_buckets[${i}][min]=${item.min}&pending_buckets[${i}][max]=${item.max}`
                  )
                  .join("&")}`
              : ""
          }
`,
          typeId: path?.includes("recievable") ? 13 : 22,
        })
        const processedData = response?.data?.data?.map(ledger => ({
          ledger_id: ledger.ledger_id,
          ledger_name: ledger.ledger_name,
          entries: ledger.voucher_entries.map(entry => ({
            voucher_id: entry.voucher_id,
            voucher_code: entry.voucher_code,
            voucher_date: entry.voucher_date,
            partial_payments: entry.partial_payments.map(payment => ({
              due_date: payment.due_date
                ? moment(payment.due_date).format("DD-MM-YYYY")
                : "-",
              total_pending_amount: payment.total_pending_amount || 0,
              pending_less_than_30_days: payment.pending_less_than_30_days || 0,
              pending_30_to_60_days: payment.pending_30_to_60_days || 0,
              pending_60_to_90_days: payment.pending_60_to_90_days || 0,
              pending_greater_than_90_days:
                payment.pending_greater_than_90_days || 0,
            })),
          })),
        }))
        // setFetchedData(response?.data?.data || [])
        const newData = response?.data?.data || []

        setFetchedData(prev => (page > 1 ? [...prev, ...newData] : newData))
        setPagination(response?.data || null)
        setIsLoadingNextPage(response == undefined ? true : false)
        isLoadingRef.current = false
      } catch (error) {
        console.error("Error fetching SOA data:", error)
        setFetchedData([])
        setPagination(null)
      }
    }

    if (path) {
      fetchData()
    }
  }, [
    page,
    search,
    dateFrom,
    dateTo,
    acc,
    location,
    path,
    refresh,
    startDate,
    endDate,
    dueOn,
    ageingPeriod,
  ])

  const {
    fields: ageingFields,
    append: ageingListAppend,
    remove: ageingListRemove,
  } = useFieldArray({
    control,
    name: "ageing",
  })

  const shouldShowLedgerColumn = !(
    location?.state?.item?.ledger_name ||
    location?.state?.name ||
    location?.state?.ledger_name
  )

  const columns = [
    {
      label: "Date",
      renderCell: item => (
        <div className="text-capitalize">{item?.par ? item?.par : ""}</div>
      ),
    },
    {
      label: "Ref",
      renderCell: item => (
        <div className="text-capitalize">{item?.par ? item?.par : ""}</div>
      ),
    },
    {
      label: "Party's Name",
      renderCell: item => (
        <div className="text-capitalize">{item?.ledger_name}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Pending Amount</div>,
      renderCell: item => (
        <div className="text-capitalize">{item?.pen ? item?.pen : ""}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">(&lt; 30 Days)</div>,
      renderCell: item => (
        <div className="text-capitalize">{item?.pen ? item?.pen : ""}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">30 to 60 Days</div>,
      renderCell: item => (
        <div className="text-capitalize">{item?.pen ? item?.pen : ""}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">60 to 90 Days</div>,
      renderCell: item => (
        <div className="text-capitalize">{item?.pen ? item?.pen : ""}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">(&gt; 90 Days)</div>,
      renderCell: item => (
        <div className="text-capitalize">{item?.pen ? item?.pen : ""}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Due On</div>,
      renderCell: item => (
        <div className="text-capitalize">{item?.pen ? item?.pen : ""}</div>
      ),
    },
    // {
    //   label: "Date",
    //   renderCell: item => moment(item?.created_at).format("DD-MM-YYYY"),
    // },
    // {
    //   label: <div className="text-end pe-5">Credit (AED)</div>,
    //   renderCell: item => <div className="text-end pe-5">{
    //     item?.credit_amount
    //       ? `${NumberFormat((Number(item?.credit_amount)))} AED`
    //       : 0
    //   }</div>
    // },
    // {
    //   label: <div className="text-end pe-5">Debit (AED)</div>,
    //   renderCell: item => <div className="text-end pe-5">{
    //     item?.debit_amount
    //       ? `${NumberFormat((Number(item?.debit_amount)), 3, 3)} AED`
    //       : 0
    //   }</div>
    // },
  ]

  // Sub-columns for voucher entries
  const subColumns = [
    {
      label: "Date",
      renderCell: item => <div></div>,
    },
    {
      label: "Ref",
      renderCell: item => <div>{item?.voucher_code}</div>, // Display Voucher Code
    },
    {
      label: "Party's Name",
      renderCell: item => <div></div>,
    },
    {
      label: <div className="text-end pe-5">Pending Amount</div>,
      renderCell: item => <div></div>,
    },
    {
      label: <div className="text-end pe-5">(&lt; 30 Days)</div>,
      renderCell: item => <div></div>,
    },
    {
      label: <div className="text-end pe-5">30 to 60 Days</div>,
      renderCell: item => <div></div>,
    },
    {
      label: <div className="text-end pe-5">60 to 90 Days</div>,
      renderCell: item => <div></div>,
    },
    {
      label: <div className="text-end pe-5">(&gt; 90 Days)</div>,
      renderCell: item => <div></div>,
    },
    {
      label: <div className="text-end pe-5">Due On</div>,
      renderCell: item => <div></div>,
    },
  ]

  // Another sub-columns for payment details
  // const anotherSubColumns = [
  //   {
  //     label: "Date",
  //     renderCell: item => <div></div>,
  //   },
  //   {
  //     label: "Ref",
  //     renderCell: item => <div></div>, // Display Voucher Code
  //   },
  //   {
  //     label: "Party's Name",
  //     renderCell: item => <div></div>,
  //   },
  //   {
  //     label: <div className="text-end pe-5">Pending Amount</div>,
  //     renderCell: item => {
  //       return item?.partial_payments?.map((el, i) => (
  //         <div className="text-end pe-1">{console.log(`chkkkk`, el)
  //         }
  //           {NumberFormat(Number(el?.total_pending_amount), 3, 3)}
  //         </div>
  //       ))
  //       // ? `${NumberFormat(Number(item?.total_pending_amount), 3, 3)}`
  //       // : 0}
  //     },
  //   },
  //   {
  //     label: <div className="text-end pe-5">(&lt; 30 Days)</div>,
  //     renderCell: (item) => {
  //       return item?.partial_payments?.map((el, i) => (
  //         <div key={i} className="text-end pe-1">
  //           {NumberFormat(Number(el?.pending_less_than_30_days || 0), 3, 3)}
  //         </div>
  //       ));
  //     },
  //   },
  //   {
  //     label: <div className="text-end pe-5">30 to 60 Days</div>,
  //     renderCell: item => (
  //       <div className="text-end pe-1">
  //         {item?.pending_30_to_60_days
  //           ? `${NumberFormat(Number(item?.pending_30_to_60_days), 3, 3)}`
  //           : 0}
  //       </div>
  //     ),
  //   },
  //   {
  //     label: <div className="text-end pe-5">60 to 90 Days</div>,
  //     renderCell: item => (
  //       <div className="text-end pe-1">
  //         {item?.pending_60_to_90_days
  //           ? `${NumberFormat(Number(item?.pending_60_to_90_days), 3, 3)}`
  //           : 0}
  //       </div>
  //     ),
  //   },
  //   {
  //     label: <div className="text-end pe-5">(&gt; 90 Days)</div>,
  //     renderCell: item => (
  //       <div className="text-end pe-1">
  //         {item?.pending_greater_than_90_days
  //           ? `${NumberFormat(
  //               Number(item?.pending_greater_than_90_days),
  //               3,
  //               3
  //             )}`
  //           : 0}
  //       </div>
  //     ),
  //   },
  //   {
  //     label: <div className="text-end pe-5">Due On</div>,
  //     renderCell: item => (
  //       <div className="text-end pe-1">
  //         {moment(item?.due_data).format("DD-MMM-YY")}
  //       </div>
  //     ),
  //   },
  // ]

  const anotherSubColumns = [
    {
      label: "Date",
      renderCell: item => (
        <div>{moment(item?.created_at).format("DD-MMM-YY")}</div>
      ),
    },
    {
      label: "Ref",
      renderCell: item => <div>{item?.payment_id || ""}</div>, // Use payment_id or another unique identifier
    },
    {
      label: "Party's Name",
      renderCell: item => <div></div>, // Empty or add relevant field if available
    },
    {
      label: <div className="text-end pe-5">Pending Amount</div>,
      renderCell: item => (
        <div className="text-end pe-1">
          {NumberFormat(
            Number(item?.total_pending_amount || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Pending Amount</div>,
      renderCell: item => (
        <div className="text-end pe-1">
          {NumberFormat(
            Number(item?.pending_less_than_30_days || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Pending Amount</div>,
      renderCell: item => (
        <div className="text-end pe-1">
          {NumberFormat(
            Number(item?.pending_30_to_60_days || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">60 to 90 Days</div>,
      renderCell: item => (
        <div className="text-end pe-1">
          {NumberFormat(
            Number(item?.pending_60_to_90_days || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">( 90 Days)</div>,
      renderCell: item => (
        <div className="text-end pe-1">
          {NumberFormat(
            Number(item?.pending_greater_than_90_days || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Due On</div>,
      renderCell: item => (
        <div className="text-end pe-1">
          {moment(item?.due_date).format("DD-MMM-YY")}
        </div>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  // const handleDateChange = (fromdate, todate) => {
  //   setDatefrom(fromdate)
  //   setDateto(todate)
  //   setPage(1)
  // }

  const handleAccChange = data => {
    setAcc(data)
    setPage(1)
  }

  const handleReset = () => {
    reset({ due_on: null, start_date: "", end_date: "" })
    setStartDate("")
    setEndDate("")
    setDueOn("")
    setRefresh(refresh + 1)
    setPage(1)
  }

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false)
  const scrollTimeoutRef = useRef(null)
  const timeoutRef = useRef(null)

  useEffect(() => {
    const handleScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = e.target

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < pagination?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      }, 200)
    }

    const container = tableContainerRef.current
    if (container) {
      container.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll)
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [fetchedData, page])

  const handleDateChange = (
    date,
    type,
    startDate,
    endDate,
    setStartDate,
    setEndDate
  ) => {
    if (!date) {
      if (type === "start") setStartDate("")
      if (type === "end") setEndDate("")
      return
    }

    const formattedDate = moment(date).format("YYYY-MM-DD")

    if (type === "start") {
      setStartDate(formattedDate)
      // If no end date, auto set to month's last day
      if (!endDate) {
        setEndDate(moment(date).endOf("month").format("YYYY-MM-DD"))
        setValue("end_date", moment(date).endOf("month").format("YYYY-MM-DD"))
      }
    }

    if (type === "end") {
      setEndDate(formattedDate)
      // If no start date, auto set to month's first day
      if (!startDate) {
        setStartDate(moment(date).startOf("month").format("YYYY-MM-DD"))
        setValue(
          "start_date",
          moment(date).startOf("month").format("YYYY-MM-DD")
        )
      }
    }
  }

  const handleAccno = e => {
    setAcc(e?.value)
  }

  const handleKeyDown = (e, index) => {
    if (e.key === "Tab") {
      let ageingLen = watch("ageing")?.length != 0 ? watch("ageing")?.length : index
      e.preventDefault() // optional, so it won't skip focus
      console.log(`index`, watch(`ageing.${index}`), ageingLen)
      if (
        watch(`ageing.${ageingLen - 1}.to_days`) != 0 &&
        watch(`ageing.${ageingLen - 1}.to_days`) > watch(`ageing.${ageingLen - 1}.from_days`) &&
        watch(`ageing.${ageingLen - 1}.to_days`) !== ""
      ) {
        ageingListAppend({
          from_days: watch(`ageing.${index}.to_days`),
          to_days: "",
        })
      } else {
        return
      }
    }
  }

  const handleRegistration = data => {
    console.log(`data`, data)
    if (
      data.ageing.length > 0 &&
      data?.ageing[data?.ageing?.length - 1]?.to_days == 0
    ) {
      setAgeingPeriod(data.ageing)
      setIsModal(false)
    } else {
      ageingListAppend({
        from_days: watch(`ageing.${data?.ageing?.length - 1}.to_days`),
        to_days: "",
      })
    }
  }

  // const handleAccno = e => {
  //   let firstPeriod = watch("first_period")
  //   let secondPeriod = watch("second_period")
  //   let period = ""
  //   if (firstPeriod && secondPeriod) {
  //     period = `pending_${firstPeriod}_to_${secondPeriod}_days`
  //   } else if (firstPeriod && !secondPeriod) {
  //     period = `pending_greater_than_${firstPeriod}_days`
  //   } else if (!firstPeriod && secondPeriod) {
  //     period = `pending_less_than_${secondPeriod}_days`
  //   } else {
  //     period = ""
  //   }
  //   setDueOn(period)
  // }

  // const handleAccno = () => {
  //   clearTimeout(timeoutRef.current) // clear previous timer

  //   timeoutRef.current = setTimeout(() => {
  //     let firstPeriod = watch("first_period")
  //     let secondPeriod = watch("second_period")
  //     let period = ""

  //     if (firstPeriod && secondPeriod) {
  //       period = `pending_${firstPeriod}_to_${secondPeriod}_days`
  //     } else if (firstPeriod && !secondPeriod) {
  //       period = `pending_greater_than_${firstPeriod}_days`
  //     } else if (!firstPeriod && secondPeriod) {
  //       period = `pending_less_than_${secondPeriod}_days`
  //     }

  //     setDueOn(period)
  //   }, 400) // waits 400ms after last change
  // }

  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            {!fromDashboard && (
              <Breadcrumbs
                title="Finance"
                breadcrumbObject={[
                  { title: "Finance", link: "/finance" },
                  { title: crumb || "Statement Of Account", link: "/finance" },
                  {
                    title: path?.includes("recievable")
                      ? "Receivables"
                      : "Payable",
                    link: path?.includes("recievable") ? "#" : "#",
                  },
                ]}
              />
            )}
            {/* <div className="pe-2 d-flex align-items-center">
              <div
                className="export-div pointer reset-img me-2 py-2"
                onClick={() => handleReset()}
              >
                <img src={resetIcon} height={15} width={15} className="" />{" "}
              </div>
              <div className="me-2">
                <DueOn
                  control={control}
                  name="due_on"
                  placeholder="Period 2"
                  // onChange={handleAccno}
                  className="w-25"
                  onSelectChange={e => handleAccno(e)}
                />
              </div>
              <div className="me-2">
                <UFDate
                  control={control}
                  name="start_date"
                  placeholder="Start Date"
                  mode="single"
                  onDateChange={([date]) =>
                    handleDateChange(
                      date,
                      "start",
                      startDate,
                      endDate,
                      setStartDate,
                      setEndDate
                    )
                  }
                  maxDate={endDate || undefined}
                  readOnly={false}
                  widthClass="w-100"
                />
              </div>
              <div className="me-2">
                <UFDate
                  control={control}
                  name="end_date"
                  placeholder="End Date"
                  mode="single"
                  // onDateChange={([date]) =>
                  //   setEndDate(date ? moment(date).format("YYYY-MM-DD") : "")
                  // }
                  onDateChange={([date]) =>
                    handleDateChange(
                      date,
                      "end",
                      startDate,
                      endDate,
                      setStartDate,
                      setEndDate
                    )
                  }
                  minDate={startDate || undefined}
                  readOnly={false}
                  widthClass="w-100"
                />
              </div>
              <>
                <div className="me-2">
                  <span id={`PopoverLegacy-1`} className="px-2 btn btn-primary">
                    Download
                  </span>
                </div>
                <UncontrolledPopover
                  placement="bottom"
                  target={`PopoverLegacy-1`}
                  trigger="legacy"
                >
                  <PopoverBody>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        downloadFinanceReceivable({
                          params: `pdf=trues${
                            path?.includes("recievable")
                              ? `&account_id=13`
                              : `&account_id=22`
                          }${
                            location?.state || acc
                              ? `&account_id=${
                                  location?.state?.item?.ledger_id
                                    ? location?.state?.item?.ledger_id
                                    : location?.state?.ledger_id
                                    ? location?.state?.ledger_id
                                    : location?.state?.id
                                    ? location?.state?.id
                                    : acc
                                }`
                              : ""
                          }${dueOn ? `&due_on=${dueOn}` : ""}`,
                          type: "pdf",
                          fileName: "statement_of_account.pdf",
                        })
                      }
                    >
                      PDF
                    </div>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        downloadFinanceReceivable({
                          params: `${
                            path?.includes("recievable")
                              ? `&account_id=13`
                              : `&account_id=22`
                          }${
                            location?.state || acc
                              ? `&account_id=${
                                  location?.state?.item?.ledger_id
                                    ? location?.state?.item?.ledger_id
                                    : location?.state?.ledger_id
                                    ? location?.state?.ledger_id
                                    : location?.state?.id
                                    ? location?.state?.id
                                    : acc
                                }`
                              : ""
                          }${dueOn ? `&due_on=${dueOn}` : ""}`,
                          type: "excel",
                          fileName: "statement_of_account.xlsx",
                        })
                      }
                    >
                      Excel
                    </div>
                    
                  </PopoverBody>
                </UncontrolledPopover>
              </>
            </div> */}
            <div className="d-flex align-items-center">
              <ButtonGroup>
                <Button
                  color="primary px-2 m-0"
                  outline
                  onClick={() => {
                    setRSelected(1)
                    setAgeingPeriod([])
                  }}
                  active={rSelected === 1}
                >
                  Default
                </Button>
                <Button
                  color="primary px-2 m-0"
                  outline
                  onClick={() => {
                    setAgeingPeriod([])
                    setRSelected(2)
                  }}
                  active={rSelected === 2}
                >
                  Detailed
                </Button>
                <Button
                  color="primary px-2 m-0"
                  outline
                  onClick={() => {
                    setRSelected(3)
                    setIsModal(true)
                  }}
                  active={rSelected === 3}
                >
                  Ageing
                </Button>
              </ButtonGroup>

              <div className="ms-2">
                <div className="me-2">
                  <span id={`PopoverLegacy-1`} className="px-2 btn btn-primary">
                    Download
                  </span>
                </div>
                <UncontrolledPopover
                  placement="bottom"
                  target={`PopoverLegacy-1`}
                  trigger="legacy"
                >
                  <PopoverBody>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        downloadFinanceReceivable({
                          params: `pdf=trues${
                            path?.includes("recievable")
                              ? `&account_id=13`
                              : `&account_id=22`
                          }${
                            location?.state || acc
                              ? `&account_id=${
                                  location?.state?.item?.ledger_id
                                    ? location?.state?.item?.ledger_id
                                    : location?.state?.ledger_id
                                    ? location?.state?.ledger_id
                                    : location?.state?.id
                                    ? location?.state?.id
                                    : acc
                                }`
                              : ""
                          }${dueOn ? `&due_on=${dueOn}` : ""}`,
                          type: "pdf",
                          fileName: "statement_of_account.pdf",
                        })
                      }
                    >
                      PDF
                    </div>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        downloadFinanceReceivable({
                          params: `${
                            path?.includes("recievable")
                              ? `&account_id=13`
                              : `&account_id=22`
                          }${
                            location?.state || acc
                              ? `&account_id=${
                                  location?.state?.item?.ledger_id
                                    ? location?.state?.item?.ledger_id
                                    : location?.state?.ledger_id
                                    ? location?.state?.ledger_id
                                    : location?.state?.id
                                    ? location?.state?.id
                                    : acc
                                }`
                              : ""
                          }${dueOn ? `&due_on=${dueOn}` : ""}`,
                          type: "excel",
                          fileName: "statement_of_account.xlsx",
                        })
                      }
                    >
                      Excel
                    </div>
                  </PopoverBody>
                </UncontrolledPopover>
              </div>
            </div>
          </div>
          <Row>
            <Col lg={12}>
              <Card className="me-2 px-2 py-2">
                {/* <Row className="mt-2">
                <Col xs={12}>
                  <JournalEntryFilter
                    handleSearchChange={handleSearchChange}
                    handleDateChange={handleDateChange}
                    handleAccChange={handleAccChange}
                  />
                </Col>
              </Row> */}
                <div className="d-flex justify-content-between align-items-center my-2 me-2">
                  <Form id="user-form" className="filter-wrapper">
                    <Row className="mx-0">
                      <Col sm={3} className="pe-1">
                        <DueOn
                          control={control}
                          name="due_on"
                          placeholder="Period 2"
                          // onChange={handleAccno}
                          className="w-25"
                          onSelectChange={e => handleAccno(e)}
                        />
                      </Col>
                      <Col sm={3} className="pe-1">
                        <UFDate
                          control={control}
                          name="start_date"
                          placeholder="Start Date"
                          mode="single"
                          onDateChange={([date]) =>
                            handleDateChange(
                              date,
                              "start",
                              startDate,
                              endDate,
                              setStartDate,
                              setEndDate
                            )
                          }
                          maxDate={endDate || undefined}
                          readOnly={false}
                          widthClass="w-100"
                        />
                      </Col>
                      <Col sm={3} className="pe-1">
                        <UFDate
                          control={control}
                          name="end_date"
                          placeholder="End Date"
                          mode="single"
                          onDateChange={([date]) =>
                            handleDateChange(
                              date,
                              "end",
                              startDate,
                              endDate,
                              setStartDate,
                              setEndDate
                            )
                          }
                          minDate={startDate || undefined}
                          readOnly={false}
                          widthClass="w-100"
                        />
                      </Col>
                    </Row>
                  </Form>
                  <div
                    className="export-div pointer reset-img me-2 py-2"
                    onClick={() => handleReset()}
                  >
                    <img src={resetIcon} height={15} width={15} className="" />{" "}
                  </div>
                </div>
                <Row className="mt-2">
                  <Col xs={12}>
                    <div
                      ref={tableContainerRef}
                      style={{ maxHeight: "490px", overflowY: "auto" }}
                    >
                      {fetchedData && (
                        <SoaTable
                          data={fetchedData}
                          pagination={pagination}
                          onPageChange={handlePageChange}
                          hidePagination={true}
                          isLoading={isLoadingNextPage}
                          currFormat={rSelected}
                          ageingPeriod={ageingPeriod}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              </Card>
              <Modal
                isOpen={isModal}
                toggle={toggleModal}
                size={"sm"}
                backdrop={"static"}
                unmountOnClose={false}
              >
                <>
                  <ModalHeader className="custom-modal-header">
                    <div className="d-flex justify-content-between">
                      <h5 className="ms-1">Ageing Alteration</h5>
                      <img
                        src={closeIcon}
                        alt=""
                        onClick={toggleModal}
                        width="10"
                        role="button"
                      />
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <FormProvider>
                      <Form
                        id={`ev-form`}
                        onSubmit={handleSubmit(handleRegistration)}
                      >
                        {ageingFields?.map((item, index) => (
                          <Row
                            key={`ageing_${index}`}
                            className="d-flex align-items-center mb-2"
                          >
                            <Col sm={2} className="pe-1">
                              <div>From:</div>
                            </Col>
                            <Col sm={4} className="pe-1">
                              <UFInputNumber
                                control={control}
                                placeholder="From"
                                name={`ageing.${index}.from_days`}
                                className="ps-1"
                                // isDecimal={true}
                                disabled={true}
                                decimalLength={0}
                              />
                            </Col>
                            <Col sm={2} className="pe-1">
                              To:
                            </Col>
                            <Col sm={4} className="pe-1">
                              <UFInputNumber
                                control={control}
                                placeholder="To"
                                name={`ageing.${index}.to_days`}
                                className="ps-1"
                                // isDecimal={true}
                                // minN
                                decimalLength={0}
                                onKeyDown={e => handleKeyDown(e, index)}
                              />
                            </Col>
                          </Row>
                        ))}

                        <Row></Row>
                      </Form>
                    </FormProvider>
                  </ModalBody>
                  <ModalFooter>
                    <LoadingButton
                      form={`ev-form`}
                      color={"primary"}
                      // loading={isLoading}
                      // disabled={isLoading}
                      type="submit"
                    >
                      Save
                    </LoadingButton>
                  </ModalFooter>
                </>
              </Modal>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default StatementOfAcc
